export default "__VITE_ASSET__R8xJkbW8__"